/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Rename_RestoredInputs */

const vi_irrigation_rename_restored = /** @type {(inputs: Irrigation_Rename_RestoredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã dùng lại tên gốc ${i?.name}`)
};

/**

* @param {Irrigation_Rename_RestoredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_rename_restored = /** @type {((inputs: Irrigation_Rename_RestoredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Rename_RestoredInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_rename_restored(inputs)
});